import { Bus } from './bus.js'

export const sphereSetup = {
  id: 'default',
  bus: Bus.i,
  stylesheets: '<auto>',
  stydefault: ['stylesheets:oid.min.css'],
  assets: '/assets/'
}